
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download",
      function () {
        return require("private-next-pages/download/index.tsx");
      }
    ]);
  